import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { FileAddOutlined, HistoryOutlined, PlusOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/PageHeader';
import { FacturasTable, FACTURA_TABLE_SCOPE } from './components/FacturasTable';
import { CobroCreateModal } from './components/CobroCreateModal';
import { useHasPermission } from '../../auth/useHasPermission';
import { useT } from '../../locales';
import { Permission } from '@aid/shared';

export function CobrosListPage() {
  const t = useT();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);
  const canCreate = useHasPermission(Permission.COBROS_CREATE);
  const canGenerate = useHasPermission(Permission.COBROS_GENERAR);

  return (
    <div>
      <PageHeader
        title={t('pages.cobros.title')}
        subtitle={t('pages.cobros.subtitle')}
        actions={
          canCreate || canGenerate ? (
            <>
              {canGenerate && (
                <Button
                  icon={<FileAddOutlined />}
                  aria-label={t('pages.cobros.generarPeriodicas')}
                  onClick={() => navigate('/facturas/generar')}
                >
                  {t('pages.cobros.generarPeriodicas')}
                </Button>
              )}
              <Button
                icon={<HistoryOutlined />}
                aria-label={t('nav.historialGeneracion')}
                onClick={() => navigate('/facturas/historial-generacion')}
              >
                {t('nav.historialGeneracion')}
              </Button>
              {canCreate && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  aria-label={t('pages.cobros.nuevaFactura')}
                  onClick={() => setCreateOpen(true)}
                >
                  {t('pages.cobros.nuevaFactura')}
                </Button>
              )}
            </>
          ) : undefined
        }
      />
      <FacturasTable scope={FACTURA_TABLE_SCOPE.GLOBAL} />
      {canCreate && <CobroCreateModal open={createOpen} onClose={() => setCreateOpen(false)} />}
    </div>
  );
}
